module.exports = __webpack_public_path__ + "static/media/chatMessageSending_2.ada3768b.mp3";